module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAALElEQVRIx2P8//8/A25wXkidgVzAOGr0qNGjRlPRaMYdiaNGjxo9ajR9jAYAsShRLXsTjDQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/mg.png
// module id = 336
// module chunks = 0